<template>
  <div class="action-drawer" v-if="appState.currentMenuAction">
    <div class="inner">
      <CropSetting v-if="appState.currentMenuAction === 'crop'" @cancel="handleCancel" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import CropSetting from '../ImageCrop/CropSetting.vue';

const store = useStore();
const appState = computed(() => store.state.app);

const handleCancel = () => {
  store.commit('app/SET_CURRENT_MENU_ACTION', '');
};
</script>

<style lang="less" scoped>
.action-drawer {
  width: 288px;
  height: 100%;
  border-left: 1px solid #ddd;
  background: #fff;
  z-index: 999;
  overflow: auto;
}
.inner {
  padding: 16px;
}
</style>
